import { render, staticRenderFns } from "./FeedFormula.vue?vue&type=template&id=6b1364e1&"
import script from "./FeedFormula.vue?vue&type=script&lang=js&"
export * from "./FeedFormula.vue?vue&type=script&lang=js&"
import style0 from "./FeedFormula.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FeedFormula.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports